import React, {useEffect, useState} from 'react';
import './QuestChestRewardModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import {ALL_CHEST_CONFIGS} from '../../../configs/chests';
import {getChestIconPath} from '../../../utils/inventory/getChestIconPath';
import {getChestDisplayName} from '../../../utils/inventory/getChestDisplayName';
import {ChestRewardLabel} from '../ChestPurchaseModal/ChestPurchaseModal';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';
import {WIN_POINTS_COLOR_LIGHT} from '../../../styles/constants';

const PAGE_ID = 'QuestChestRewardModal';

/**
 * Сундук, полученный за выполненное задание. Содержимое — как в модалке
 * сундука в магазине (обложка, название, таблица наград с вероятностями),
 * плюс поздравительная строка и переходы: в коллекцию (открыть сундук) и в
 * магазин за новыми сундуками.
 */
const QuestChestRewardModal = ({chestId, onOpenInventory, onMoreChests, onClose}) => {
  const [visible, setVisible] = useState(false);
  const chest = ALL_CHEST_CONFIGS.find((config) => config.id === chestId);

  useEffect(() => {
    MENU_SOUND_MANAGER.playChestOpen?.();
    const timeoutId = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timeoutId);
  }, []);

  if (!chest) {
    return null;
  }

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose?.(), 300);
  };

  return (
    <div
      className={`quest-chest-reward-overlay ${visible ? 'quest-chest-reward-overlay_visible' : ''}`}
      onClick={handleClose}
      role={'dialog'}
      aria-modal={'true'}
      style={{'--chest-shadow-color': chest.shadowColor ?? WIN_POINTS_COLOR_LIGHT}}
    >
      <div
        className={`quest-chest-reward-modal ${visible ? 'quest-chest-reward-modal_visible' : ''}`}
        onClick={(event) => event.stopPropagation()}
      >
        <div className={'quest-chest-reward-content'}>
          <h2 className={'quest-chest-reward-congratulation'}>Задание выполнено!</h2>
          <div className={'quest-chest-reward-image-wrapper'}>
            <img className={'quest-chest-reward-image'} src={getChestIconPath(chest.id)} alt={getChestDisplayName(chest.id)}/>
          </div>

          <p className={'quest-chest-reward-subtitle'}>Ваша награда:</p>

          {/* Имя берется из getChestDisplayName, а не из chest.name: у сундуков
              лиг (награда за задания на лигу) собственного имени в конфиге
              нет, и заголовок модалки оказывался пустым */}
          <h3
            className={'quest-chest-reward-name'}
            style={{color: chest.textColor || chest.modalTextColor}}
          >
            {getChestDisplayName(chest.id)}
          </h3>

          <ul className={'chest-purchase-rewards-list'}>
            <li key={'header'} className={'chest-purchase-reward-row'}>
              <span className={'chest-purchase-reward-label chest-purchase-reward-label_neutral'}>Награда</span>
              <span className={'chest-purchase-reward-chance'}>Вероятность</span>
            </li>
            {/* Порядок как в магазине: самое ценное (в конфиге последнее) сверху */}
            {[...chest.rewards].reverse().map((reward, index) => (
              <li key={index} className={'chest-purchase-reward-row'}>
                <ChestRewardLabel reward={reward}/>
                <span className={'chest-purchase-reward-chance'}>{reward.chance}%</span>
              </li>
            ))}
          </ul>

          <div className={'main-menu-buttons quest-chest-reward-buttons'}>
            <PageButton onClick={onOpenInventory} pageId={PAGE_ID} buttonId={'open_inventory'}>
              Открыть в коллекции
            </PageButton>
            <PageButton onClick={onMoreChests} pageId={PAGE_ID} buttonId={'more_chests'}>
              Больше сундуков
            </PageButton>
            <PageButton
              className={'main-menu-button_secondary'}
              onClick={handleClose}
              pageId={PAGE_ID}
              buttonId={'hide'}
            >
              Скрыть
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestChestRewardModal;
